import * as XLSX from 'xlsx';

export const generateTransactionExcel = (formattedData, fromDate, toDate) => {
    try {
        const wb = XLSX.utils.book_new();
        const headers = [
            'Date',
            'Branch Id',
            'Description',
            'Type',
            'Debit (AED)',
            'Credit (AED)',
            'Bank Reference Number'
        ];

        const dataWithHeaders = [headers, ...formattedData.map(row => [
            row.date,
            row.branchId,
            row.description,
            row.type,
            row.debit,
            row.credit,
            row.bankReference
        ])];

        const ws = XLSX.utils.aoa_to_sheet(dataWithHeaders);
        XLSX.utils.book_append_sheet(wb, ws, 'Ledger');
        const filename = `TransactionStatement_${fromDate}_to_${toDate}.xlsx`;
        XLSX.writeFile(wb, filename);

        return true;
    } catch (error) {
        return false;
    }
};

export default generateTransactionExcel; 